import { ThemeMode } from './types'

export const REDESIGN_THEME_STORAGE_KEY = 'digaah:redesign:theme:v1'

export const isThemeMode = (value: unknown): value is ThemeMode =>
  value === 'system' || value === 'light' || value === 'dark'

export const readStoredThemeMode = (): ThemeMode => {
  if (typeof window === 'undefined') return 'system'

  try {
    const storedMode = window.localStorage.getItem(REDESIGN_THEME_STORAGE_KEY)
    return isThemeMode(storedMode) ? storedMode : 'system'
  } catch {
    return 'system'
  }
}

export const storeThemeMode = (mode: ThemeMode) => {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.setItem(REDESIGN_THEME_STORAGE_KEY, mode)
  } catch {
    // The preference remains available for the current session.
  }
}
